var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom" }, [
    _c(
      "div",
      {
        staticClass: "select-box-multiselect",
        class: { disabled: _vm.disable },
        on: { click: _vm.toggleDropdown },
      },
      [
        _vm.selectedLabels.length
          ? _c(
              "span",
              {
                staticClass: "selected-labels",
                attrs: { title: _vm.selectedLabels.join(", ") },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.selectedLabels.join(", ")) + "\n    "
                ),
              ]
            )
          : _c("span", { staticClass: "placeholder" }, [
              _vm._v(_vm._s(_vm.placeholder)),
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "arrow" }, [
          _c(
            "svg",
            {
              attrs: {
                fill: _vm.arrowColor(),
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", { attrs: { d: "M7 10l5 5 5-5z" } }),
              _vm._v(" "),
              _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } }),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.isOpen && !_vm.disable
      ? _c(
          "div",
          { staticClass: "dropdown-multiselect" },
          _vm._l(_vm.options, function (option) {
            return _c(
              "label",
              { key: option.value, staticClass: "multiselect-option" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedValues,
                      expression: "selectedValues",
                    },
                  ],
                  staticClass: "mr-2",
                  attrs: { type: "checkbox", disabled: _vm.disable },
                  domProps: {
                    value: option.value,
                    checked: Array.isArray(_vm.selectedValues)
                      ? _vm._i(_vm.selectedValues, option.value) > -1
                      : _vm.selectedValues,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.selectedValues,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = option.value,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.selectedValues = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.selectedValues = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.selectedValues = $$c
                      }
                    },
                  },
                }),
                _vm._v("\n      " + _vm._s(option.label) + "\n    "),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }